<script>
export default {
  name: 'StatusVideo',
  props: ['value'],
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      visulalizacao: 11,
      playes: 7

    }
  },

  mounted() {
   
  },
  computed: {
    stateAnalytic: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    getVisualizações() {

      return this.visulalizacao
    },
    getPlays() {
      return this.playes
    },
    getPlayRate() {
      if (this.stateAnalytic != null) {
        const playRate = this.stateAnalytic.qtde_play / this.stateAnalytic.qtde_load * 100
        return playRate.toFixed(0)
      }
      return 0
    },
  
  }
  
}
</script>


<template>
  <div class="container overflow-hidden px-0">
    <div class="row align-items-md-center gy-3 mt-1 text-center justify-content-md-center">
      <div class="col-12 col-md-3 col-sm-6 mt-sm-2" style="min-width: 180px; max-width: 15rem;  ">
        <div class=" border bg-light">

          <p class="col pt-1 px-0" data-toggle="tooltip">Visualizações

            <el-tooltip class="item" effect="dark" content="Número de vezes que a página foi carregada com o player"
              placement="top-start">
              <span><feather-icon icon="HelpCircleIcon" size="15" stroke="gray" class="mr-50" /></span>
            </el-tooltip>
          </p>

          <p>{{ stateAnalytic != null ? stateAnalytic.qtde_load : 0 }}</p>
        </div>
      </div>
      <div class="col-12 col-md-3 col-sm-6 mt-sm-2 mt-2" style="min-width: 180px; max-width: 15rem">
        <div class=" border bg-light">
          <div class="row ">

            <p class="col pt-1 px-0" data-toggle="tooltip">Plays

              <el-tooltip class="item" effect="dark" content="Número de vezes que os usuários iniciam o vídeo"
                placement="top-start">
                <span><feather-icon icon="HelpCircleIcon" size="15" stroke="gray" class="mr-50" /></span>
              </el-tooltip>
            </p>
          </div>

          <p>{{ stateAnalytic != null  ? stateAnalytic.qtde_play : 0 }}</p>
        </div>
      </div>
      <div class="col-12 col-md-3 col-sm-6 mt-sm-2 mt-2" style="min-width: 180px; max-width: 15rem">
        <div class=" border bg-light">
          <div class="row ">

            <p class="col pt-1 px-0" data-toggle="tooltip">Play Rate
              <el-tooltip class="item" effect="dark" content="Porcentagem de plays em relação ás visualizações do vídeo"
                placement="top-start">
                <span><feather-icon icon="HelpCircleIcon" size="15" stroke="gray" class="mr-50" /></span>
              </el-tooltip>

            </p>
          </div>

          <p>{{ stateAnalytic != null && stateAnalytic.playRate != null ? stateAnalytic.playRate : 0 }}%</p>
        </div>
      </div>
      <div class="col-12 col-md-3 col-sm-6 mt-sm-2 mt-2 " style="min-width: 180px; max-width: 15rem">
        <div class=" border bg-light">
          <div class="row ">

            <p class="col pt-1 px-0">Engajamento
              <el-tooltip class="item" effect="dark"
                content="Total do vídeo assistido dividido pela quantidade de plays multiplicado pela duração do vídeo"
                placement="top-start">
                <span><feather-icon icon="HelpCircleIcon" size="15" stroke="gray" class="mr-50" /></span>
              </el-tooltip>

            </p>
          </div>

          <p>{{ stateAnalytic != null && stateAnalytic.engajamento != null? stateAnalytic.engajamento : 0 }}%</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#views {
  background-color: #65ddc1;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#views:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

}


#paly {
  background-color: #fbc77b;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#PlayRate {
  background-color: #6aaef9;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#Engajamento {
  background-color: #f17c92;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.218);
}

#textView {
  color: #266355;
}

#textPlay {
  color: #986f3a;
}

#textPlayRate {
  color: #2b5485;
}

#textEngajamento {
  color: #983545;
}

#text2 {
  color: #424242
}
</style>